export const authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJmMmE2NzE0Ni02ZGRjLTRiZDMtYWUzYS05ZGJjODI0MjY4ZWUiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTczMDY5ODk2NywiZXhwIjoxNzMwNzA2MTY3fQ.WkNbcrW-f16nnWuR01B61w3mum8vLrSC3u3qrjZKKss";

export const createNewRoom = async () => {
  const res = await fetch(`https://api.videosdk.live/v2/rooms`, {
    method: "POST",
    headers: {
      authorization: `${authToken}`,
      "Content-Type": "application/json",
    },
  });

  const { roomId } = await res.json();
  return roomId;
};
